export default {
    SET_PROFIL: (state, data) => (state.profil = data),
};